import placesListModule from '../placesListModule';

function gameCard(resources) {
  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    replace: true,
    templateUrl: resources.templateUrls.gameCard
  };
}

placesListModule.directive('gameCard', gameCard);

export default gameCard;
